import { InfoField } from '@occc/ui-design-system';
import { ConstraintFragment } from '@occc/graphql';
import { formatYesNoValues } from '../../formatters';

export const OrderAheadOnlyConstraint = ({
  constraints,
}: {
  constraints: ConstraintFragment[];
}) => {
  const cst = constraints.filter((c) => c.__typename === 'ConstraintOrderAheadOnly');

  return (
    <InfoField label='Order Ahead Only' value={cst.length ? formatYesNoValues(cst) : undefined} />
  );
};
